export enum AddProductsFormValueKey {
    productId = 'productId',
    consumedUtc = 'consumedUtc',
    quantity = 'quantity',
    claimForToday = 'claimForToday',
}
